module.exports = {
	"pagination": {
		"DescribeCachediSCSIVolumes": {
			"result_key": "CachediSCSIVolumes"
		},
		"DescribeStorediSCSIVolumes": {
			"result_key": "StorediSCSIVolumes"
		},
		"DescribeTapeArchives": {
			"input_token": "Marker",
			"limit_key": "Limit",
			"output_token": "Marker",
			"result_key": "TapeArchives"
		},
		"DescribeTapeRecoveryPoints": {
			"input_token": "Marker",
			"limit_key": "Limit",
			"output_token": "Marker",
			"result_key": "TapeRecoveryPointInfos"
		},
		"DescribeTapes": {
			"input_token": "Marker",
			"limit_key": "Limit",
			"output_token": "Marker",
			"result_key": "Tapes"
		},
		"DescribeVTLDevices": {
			"input_token": "Marker",
			"limit_key": "Limit",
			"output_token": "Marker",
			"result_key": "VTLDevices"
		},
		"ListGateways": {
			"input_token": "Marker",
			"limit_key": "Limit",
			"output_token": "Marker",
			"result_key": "Gateways"
		},
		"ListLocalDisks": {
			"result_key": "Disks"
		},
		"ListVolumeRecoveryPoints": {
			"result_key": "VolumeRecoveryPointInfos"
		},
		"ListVolumes": {
			"input_token": "Marker",
			"limit_key": "Limit",
			"output_token": "Marker",
			"result_key": "VolumeInfos"
		}
	}
};


//////////////////
// WEBPACK FOOTER
// ./~/aws-sdk/apis/storagegateway-2013-06-30.paginators.json
// module id = 701
// module chunks = 0